export * from './src/multilingual-genericconverter-v1-entity-mapper-entity-mapper.universal.js';
